import * as React from 'react';
import { SectionHeadWrapper, IconContainer, StyledSectionHead } from './styles.js';

const SectionHead = ({ title, icon = null, classNames = {} }) => {
    return (React.createElement(SectionHeadWrapper, null,
        icon && React.createElement(IconContainer, { className: classNames.iconContainer }, icon),
        React.createElement(StyledSectionHead, { className: classNames.sectionHead }, title)));
};

export { SectionHead };
